import { render, staticRenderFns } from "./save-sign.vue?vue&type=template&id=165fb59d&"
import script from "./save-sign.vue?vue&type=script&lang=js&"
export * from "./save-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports